var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-item-group',{attrs:{"multiple":""}},[_vm._l((_vm.messages),function(item,index){return [_c('conversation-item',{key:index,attrs:{"conversationItem":item,"index":index}}),(index + 1 < _vm.messages.length)?_c('v-divider'):_vm._e()]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }